class TokenManager {
  static TOKEN_KEY = "access_token";
  static CREDENTIALS_KEY = "user_credentials";

  static store(token) {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  static retrieve() {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  static clear() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.CREDENTIALS_KEY);
  }

  static storeCredentials(username, password) {
    const credentials = { username, password };
    localStorage.setItem(this.CREDENTIALS_KEY, JSON.stringify(credentials));
  }

  static getStoredCredentials() {
    try {
      const stored = localStorage.getItem(this.CREDENTIALS_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  static decode(token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload;
    } catch (error) {
      return null;
    }
  }

  static isExpired(token) {
    const payload = this.decode(token);
    if (!payload || !payload.exp) return true;

    const currentTime = Date.now() / 1000;
    return payload.exp <= currentTime;
  }

  static isValid(token) {
    if (!token) return false;
    return !this.isExpired(token);
  }
}

export default TokenManager;
